import React from 'react';
import { motion } from 'framer-motion';
import { FileText, ClipboardCheck, Book, Briefcase } from 'lucide-react';
const bonuses = [{
  title: 'Banco de Actividades Adicionales de Taller',
  icon: <FileText size={24} data-id="element-19" />,
  color: 'text-terracota',
  bg: 'bg-terracota/10',
  purpose: 'Actividades prácticas listas para usar, organizadas por tema y nivel de dificultad.',
  types: ['Investigaciones guiadas', 'Análisis de casos reales', 'Actividades de repaso y cierre', 'Trabajos individuales y grupales', 'Prácticas de aplicación en el taller'],
  result: 'Nunca llegás al taller sin una actividad que tenga sentido técnico y pedagógico.'
}, {
  title: 'Banco de Evaluaciones de Tecnología de Alimentos',
  icon: <ClipboardCheck size={24} data-id="element-20" />,
  color: 'text-petrol',
  bg: 'bg-petrol/10',
  purpose: 'Evaluaciones escritas y prácticas listas, con criterios de corrección alineados a cada tomo.',
  types: ['Selección múltiple', 'Verdadero o falso', 'Preguntas abiertas', 'Análisis de casos', 'Evaluaciones integradoras por unidad'],
  result: 'No construís un examen desde cero bajo presión nunca más. Tenés todo listo para cada trimestre.'
}, {
  title: 'Recetario Técnico de Referencia',
  icon: <Book size={24} data-id="element-21" />,
  color: 'text-gold',
  bg: 'bg-gold/10',
  purpose: 'Un recetario técnico completo con las formulaciones más importantes de cada área de procesamiento.',
  types: ['Ingredientes con porcentajes exactos', 'Parámetros de control: pH, Brix, temperatura', 'Puntos críticos de inocuidad', 'Procedimiento paso a paso'],
  result: 'Listo para entregar a tus alumnos o proyectarlo en el taller. Ningún alumno elabora un producto sin conocer los parámetros correctos.'
}, {
  title: 'Proyectos Productivos Extra',
  icon: <Briefcase size={24} data-id="element-22" />,
  color: 'text-olive',
  bg: 'bg-olive/10',
  purpose: 'Una colección de proyectos productivos adicionales listos para implementar.',
  types: ['Descripción del producto', 'Formulación técnica', 'Análisis de costos', 'Estrategia de empaque', 'Canal de comercialización sugerido'],
  result: 'Perfectos para trabajos integradores, ferias escolares y emprendimientos. Tus alumnos tienen proyectos reales listos para presentar.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-green" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <div className="text-center mb-16" data-id="element-25">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-cream mb-4" data-id="element-26">
            4 recursos docentes incluidos sin costo extra
          </h2>
          <p className="text-xl text-cream-light opacity-80" data-id="element-27">
            Diseñados para reducir todavía más el tiempo de preparación
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-28">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-warmwhite rounded-2xl p-8 relative shadow-lg" data-id="element-29">
              <div className="absolute top-0 right-0 bg-gold text-white px-4 py-1 rounded-bl-xl rounded-tr-2xl font-bold text-xs uppercase tracking-wider" data-id="element-30">
                INCLUIDO
              </div>

              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 ${bonus.bg} ${bonus.color}`} data-id="element-31">
                {bonus.icon}
              </div>

              <h3 className="text-xl font-bold text-green mb-4 pr-16" data-id="element-32">
                {bonus.title}
              </h3>

              <div className="mb-4" data-id="element-33">
                <span className="text-xs font-bold text-slate uppercase tracking-wider block mb-1" data-id="element-34">
                  ¿Para qué sirve?
                </span>
                <p className="text-ink text-sm" data-id="element-35">{bonus.purpose}</p>
              </div>

              <div className="mb-6" data-id="element-36">
                <span className="text-xs font-bold text-slate uppercase tracking-wider block mb-2" data-id="element-37">
                  Incluye:
                </span>
                <ul className="space-y-1" data-id="element-38">
                  {bonus.types.map((type, i) => <li key={i} className="flex items-start gap-2 text-sm text-ink" data-id="element-39">
                      <span className={bonus.color} data-id="element-40">✓</span>
                      <span data-id="element-41">{type}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-cream p-4 rounded-xl border border-cream-dark mt-auto" data-id="element-42">
                <span className="text-xs font-bold text-green uppercase tracking-wider block mb-1" data-id="element-43">
                  Resultado:
                </span>
                <p className="text-ink text-sm font-medium" data-id="element-44">{bonus.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}